import { getHeaders } from '../helpers';
import { getChestApiUrl } from '../../helpers/index';

/**
 * Sends a register action to the metrics endpoint giving the user state.
 * @param {Object} params The params, containing session, productType and state
 */
const register = ({ session, productType, state }) => {
  return new Promise((resolve, reject) => {
    return fetch(`${getChestApiUrl()}/chestApi/metric`, {
      method: 'POST',
      headers: getHeaders(),
      body: JSON.stringify({ session, type: productType, state })
    })
      .then(r => r.json())
      .then(res => {
        if (!res.error) return resolve(res);
        return reject(res.error);
      })
      .catch(err => reject(err));
  });
}

export default {
  register
}